import {
    type ActionFlowNode,
    type FlowNodeResultADT,
    generateVariableValue,
    resolvedUpstreamVariableValue,
    type WechatSubscriptionMessageNotificationActionConfigure,
    type WechatSubscriptionMessageNotificationsConfig
} from '@lighthouse/shared'
import { safeToString } from '@lighthouse/tools'
import { t } from 'i18next'

import * as srv from '@/services'

import type { ExecuteActionParams } from '../type'

export const sendMiniProgramSubscriptionMsgStream = async (
    node: ActionFlowNode<WechatSubscriptionMessageNotificationActionConfigure>,
    params: ExecuteActionParams
): Promise<undefined | FlowNodeResultADT> => {
    const {
        data: { config }
    } = node

    if (!config) {
        throw new Error(t('configurationNotPerfect'))
    }

    const isSend = await sendMiniProgramSubscriptionMsg(config, params)

    return await Promise.resolve({
        type: 'record',
        success: isSend
    })
}

export const sendMiniProgramSubscriptionMsg = async (config: WechatSubscriptionMessageNotificationsConfig, params: ExecuteActionParams) => {
    const { actionEvents } = params
    const { page, templateId, personList: configAddresseeIds, values } = config

    const pageUrl = await actionEvents.getPageUrl({ ...page, executeParams: params })
    const pagePathname = pageUrl ? `https://${pageUrl}` : undefined
    const url = pagePathname ? `pages/index/index?webviewUrl=${encodeURIComponent(pagePathname)}` : 'pages/index/index'
    const persons = resolvedUpstreamVariableValue({ data: configAddresseeIds, extraParams: params })

    const valuesValues = values.map(value => {
        const v = generateVariableValue({
            innerType: 'TEXT',
            jsonContent: value.value,
            extraParams: params,
            options: {
                useFileUrl: true,
                format: true
            }
        })
        return {
            variableName: value.variableName,
            value: safeToString(v)
        }
    })
    return srv.activeWechatSubscriptionMsgNotificationAction({
        addresseeIds: persons,
        templateId,
        url,
        values: valuesValues
    })
}
